// frontend/src/api/services.js
import { apiClient } from './index';

const servicesApi = {
  // --- USER ENDPOINTS ---

  /**
   * Submit a new service booking request
   * @param {Object} bookingData - { vehicle_id, service_category_id, service_type, preferred_date, preferred_time_slot, description, address }
   */
  bookService: async (bookingData) => {
    return await apiClient.post('/services/book', bookingData);
  },

  /**
   * Get the current user's booking history
   */
  getBookingHistory: async () => {
    return await apiClient.get('/services/history');
  },

  /**
   * Get details of a specific invoice (for customer review)
   * @param {string} invoiceId 
   */
  getInvoiceDetails: async (invoiceId) => {
    return await apiClient.get(`/services/invoice/${invoiceId}`);
  },

  // --- ADMIN ENDPOINTS ---

  /**
   * Get ALL bookings (Admin only)
   */
  getAllBookingsAdmin: async () => {
    return await apiClient.get('/services/admin/all');
  },

  /**
   * Update booking status (Admin only)
   * @param {string} bookingId 
   * @param {string} status - 'pending', 'confirmed', 'in_progress', 'completed', 'cancelled'
   * @param {string} adminNotes - Optional notes
   */
  updateBookingStatus: async (bookingId, status, adminNotes) => {
    return await apiClient.put(`/services/admin/${bookingId}/status`, { 
      status, 
      admin_notes: adminNotes 
    });
  }
};

export { servicesApi };